export const PAYMENT_PAY_NOW = 'PAY-NOW'



// WEBPACK FOOTER //
// ./src/constant/localStorage.js